module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.d414a87f.ttf";